export const NEW_TAB_PRODUCT_NAME = 'WebCatalog New Tab';
